<span class="content" fxLayout="row" fxLayoutAlign=" space-between center">
  <div class="inner"><ng-content></ng-content></div>
  <button *ngIf="canDelete" class="close-button" (click)="onDelete()">
    <mat-icon>cancel</mat-icon>
  </button>
</span>
